module.exports = __webpack_public_path__ + "static/media/logo.d0c4c970.svg";